<template>
  <ExecutingCourseManager v-if="!activeElement.loading && activeElement.item" :element="activeElement.item" />
</template>

<script>
import ExecutingCourseManager from '@/components/course/ExecutingCourseManager.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapActions, mapState } = createNamespacedHelpers('courseExecution');

export default {
  components: {
    ExecutingCourseManager
  },
  computed: mapState({
    activeElement: state => state.executingCourse.activeElement
  }),
  async mounted() {
    const result = await this.selectElementToExecute({
      elementId: Number(this.$route.params.elementId)
    });
    if (!result) {
      try {
        await this.$router.push('/');
      } catch (e) {
        // ignore error
      }
    }
  },
  beforeDestroy() {
    this.clearElementToExecute();
  },
  methods: {
    ...mapActions(['selectElementToExecute', 'clearElementToExecute'])
  }
};
</script>
